module.exports = __webpack_public_path__ + "assets/6f273e1e676ca210c758afcb94264368.svg";